import { render } from "./CIcon.vue?vue&type=template&id=06ee893a"
import script from "./CIcon.vue?vue&type=script&lang=js"
export * from "./CIcon.vue?vue&type=script&lang=js"

import "./CIcon.vue?vue&type=style&index=0&id=06ee893a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__